const dataName = 'gift'
export default dataName